import getUserAgent from './getUserAgent.js';
import testUserAgent from './testUserAgent.js';
import versionsRegex from './versionsRegex.json';

export default {
  android() {
    let version = '';
    const [releaseName, releaseMatch] = testUserAgent(versionsRegex.android);
    if (releaseName) {
      version = releaseName;
      if (releaseMatch && releaseMatch.length === 2) {
        version = `${releaseMatch[1]} (${releaseName})`;
      }
    }
    return version;
  },
  ios() {
    // iphone
    // Mozilla/5.0 (iPhone; CPU iPhone OS 10_3_1 like Mac OS X) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.0 Mobile/14E304 Safari/602.1

    // ipad
    // Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1
    const pattern = new RegExp(...versionsRegex.ios);
    const match = getUserAgent().match(pattern);
    
    return match && match.length === 2 ? `${match[1].split('_').join('.')}` : '';
  },
  chrome_os() {
    // x86
    // Mozilla/5.0 (X11; CrOS x86_64 11895.95.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.125 Safari/537.36

    // arm
    // Mozilla/5.0 (X11; CrOS armv7l 10575.58.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/67.0.3396.99 Safari/537.36
    const pattern = new RegExp(...versionsRegex.chrome_os);
    const match = getUserAgent().match(pattern);

    return match && match.length === 2 ? match[1] : '';
  },
  mac_os() {
    // chrome and safari
    // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.157 Safari/537.36
    // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1.1 Safari/605.1.15

    // firefox
    // Mozilla/5.0 (Macintosh; Intel Mac OS X 10.13; rv:61.0) Gecko/20100101 Firefox/61.0

    const pattern = new RegExp(...versionsRegex.mac_os);
    const match = getUserAgent().match(pattern);

    // chrome / safari have '_' we need to deal with. we can ignore the '.' in ff.
    return match && match.length === 2 ? `${match[1].split('_').join('.')}` : '';
  },
};